import { JRCInputTinyMCERaw, JRCInputTinyMCERawProps } from '../../Form/Input/JRCInputTinyMCERaw/JRCInputTinyMCERaw';
import {
    DriveOrFilebank,
    JRCInputFileAdvancedRaw,
} from '../../Form/Input/JRCInputFileAdvanced/JRCInputFileAdvancedRaw';
import { JRCButton } from '../../JRCButton/JRCButton';
import React, { useState } from 'react';
import { jCommentList, JFileApi } from 'jamespot-user-api';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import { JDriveApi } from 'jamespot-user-api/lib/src/apis/drive/drive';
import { FoldersHandlers } from '../../JRCFolders/types';

const AttachmentsInputWrapper = styled.div`
    margin: 8px 0 16px 0;
`;

const TinyMCEWrapper = styled.div`
    width: 100%;
    margin-bottom: 4px;
`;

const EditCommentActions = styled.div`
    display: flex;
    justify-content: right;
    margin: 8px 0;
    gap: 8px;
`;

export type EditCommentProps = {
    comment: jCommentList;
    activeDrives: DriveOrFilebank[];
    tinyMCEConfig: Pick<JRCInputTinyMCERawProps, 'commonOptions' | 'mentionsQueries' | 'tinymceScriptSrc'>;
    commentContent: string | null;
    setCommentContent: (content: string) => void;
    token: string;
    handlers?: FoldersHandlers & {
        file: Pick<JFileApi, 'copy'>;
        drive: Pick<
            JDriveApi,
            | 'msDocuments'
            | 'dropboxDocuments'
            | 'groups'
            | 'tenants'
            | 'listAccount'
            | 'isAccountLogged'
            | 'checkAccountToken'
            | 'getAccount'
            | 'logout'
            | 'setDefaultAccount'
            | 'getDocument'
        >;
    };
    deleteFile?: (id: number) => Promise<void>;
    onError?: (code?: string) => void;
    closeEditMode: () => void;
    updateComment: () => void;
    loading: boolean;
};

export const EditComment = ({
    comment,
    tinyMCEConfig,
    activeDrives,
    setCommentContent,
    commentContent,
    token,
    handlers,
    deleteFile,
    onError,
    closeEditMode,
    updateComment,
    loading,
}: EditCommentProps) => {
    const intl = useIntl();
    const [attachments, setAttachments] = useState(comment._attachedFiles ?? []);

    return (
        <>
            <TinyMCEWrapper>
                <JRCInputTinyMCERaw
                    {...tinyMCEConfig}
                    token={token}
                    onChange={setCommentContent}
                    value={commentContent ?? ''}
                    height={250}
                    autofocus
                />
            </TinyMCEWrapper>
            <AttachmentsInputWrapper>
                <JRCInputFileAdvancedRaw
                    deleteFile={deleteFile}
                    onUploadSuccess={(f) => setAttachments([...attachments, f])}
                    onDeleteSuccess={(f) => setAttachments(attachments.filter((_, i) => f !== i))}
                    token={token}
                    activeDrives={activeDrives}
                    multiple
                    handlers={handlers}
                    dispatchOnError={onError}
                    existingFiles={comment._attachedFiles}
                />
            </AttachmentsInputWrapper>
            <EditCommentActions>
                <JRCButton noMargin color={'cancel'} onClick={closeEditMode}>
                    {intl.formatMessage({ id: 'GLOBAL_Cancel' })}
                </JRCButton>
                <JRCButton
                    noMargin
                    color={'primary'}
                    disabled={!commentContent || !token || loading}
                    loader={loading}
                    onClick={updateComment}>
                    {intl.formatMessage({ id: 'GLOBAL_Save' })}
                </JRCButton>
            </EditCommentActions>
        </>
    );
};
